module.exports = __webpack_public_path__ + "img/_dragged.7bb5ec64.svg";